import {Component, forwardRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Editor, NgxEditorComponent, NgxEditorModule} from 'ngx-editor';

import {EDITOR_TOOLBAR} from '../../../core/constants';

@Component({
  selector: 'app-editor',
  imports: [
    NgxEditorModule,
  ],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => EditorComponent), multi: true},
  ],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.css',
})
export class EditorComponent implements OnInit, OnDestroy, ControlValueAccessor {
  protected readonly EDITOR_TOOLBAR = EDITOR_TOOLBAR;

  editor!: Editor;

  @ViewChild('editorComponent', {static: true}) editorComponent!: NgxEditorComponent;

  ngOnInit() {
    this.editor = new Editor();
  }

  ngOnDestroy() {
    this.editor.destroy();
  }

  writeValue(obj: any): void {
    if (!this.editorComponent.editor) {
      return;
    }
    this.editorComponent.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.editorComponent.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.editorComponent.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    if (!this.editorComponent.editor) {
      return;
    }
    this.editorComponent.setDisabledState(isDisabled);
  }
}
